import { useContext, useEffect, useState } from "react";
import { SiteColorsContext } from "../SiteColorsProvider/SiteColorsProvider";
import { Box, Input, Table, TableContainer, Tbody, Th, Thead, Tr } from "@chakra-ui/react";

export function SitesColorsManager() {
  const { sitesColors, setSiteColor } = useContext(SiteColorsContext);

  return (
    <Box p={4}>
      <TableContainer>
        <Table variant={"striped"}>
          <Thead>
            <Tr>
              <Th>Site</Th>
              <Th>Color</Th>
            </Tr>
          </Thead>
          <Tbody>
            {Object.entries(sitesColors).map(([site, color]) => (
              <SiteRow key={site} site={site} color={color.color} setSiteColor={setSiteColor} />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export function SiteRow({
  site,
  color,
  setSiteColor,
}: {
  site: string;
  color: string;
  setSiteColor: (site: string, color: string) => void;
}) {
  const [value, setValue] = useDelaySetter<string>(color, (color) => setSiteColor(site, color));

  return (
    <Tr key={site}>
      <Th>{site}</Th>
      <Th>
        <Input type="color" value={value} onChange={(e) => setValue(e.target.value)} />
      </Th>
    </Tr>
  );
}

export function useDelaySetter<T>(initialValue: T, setter: (value: T) => void): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(initialValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (value !== initialValue) setter(value);
    }, 500);

    return () => clearTimeout(timeout);
  }, [value, setter, initialValue]);

  return [value, setValue];
}
